import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileMenuService {
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);

  get isOpen$(): Observable<boolean> {
    return this.isOpenSubject.asObservable();
  }

  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  open(): void {
    this.isOpenSubject.next(true);
  }

  close(): void {
    this.isOpenSubject.next(false);
  }
}
